import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import Reduxify from "../../services/ReduxifyController";
import { t } from "i18next";
import {
    propTypes,
    defaultProps,
    mapStateToProps,
    mapDispatchToProps,
} from "./Editor.props";
import { SET_PROMO_FIELD, REDIRECT_TO_UPDATED_PROMO } from "./Editor.actions";
import Moment from "react-moment";
import { fetchFields, applyFieldValues } from "./Editor.functions";
import {
    Button,
    ButtonGroup,
    DropdownButton,
    MenuItem,
    Form,
    Row,
    Col,
    FormGroup,
    ToggleButton,
    ToggleButtonGroup,
    Label,
    Alert,
} from "react-bootstrap";
import { Preview } from "../../components/Preview";
import { Footer } from "../../containers/Footer";
import { SET_PROMO } from "./Editor.actions";
import { FormFields } from "../../components/FormFields";
import tbkApi from "../../services/tbkApi";
import classNames from "classnames";
import dispatchCustomEvent from "../../services/CustomEvents";
import { each, map } from "lodash";
import { toast } from "react-toastify";

class Editor extends Component {
    static propTypes = propTypes;
    static defaultProps = defaultProps;
    static mapStateToProps = mapStateToProps;
    static mapDispatchToProps = mapDispatchToProps;

    constructor(props, context) {
        super(props, context);

        if (!this.props.fields) {
            this.props.dispatch(fetchFields());
        }

        this.formRef = React.createRef();
        this.previewRefs = {
            xs: React.createRef(),
            xl: React.createRef(),
            sm: React.createRef(),
            lg: React.createRef(),
        };
        this.handleFormChange = this.handleFormChange.bind(this);
        this.handlePreviewIframeReady = this.handlePreviewIframeReady.bind(
            this,
        );
        this.customUploadRef = React.createRef();

        this.state = {
            files: [],
        };
    }

    componentDidMount() {
        document.addEventListener("change", this.handleFormChange);
        window.addEventListener("previewReady", this.handlePreviewIframeReady);
        this.setPromo();
    }

    componentWillUnmount() {
        document.removeEventListener("change", this.handleFormChange);
        window.removeEventListener(
            "previewReady",
            this.handlePreviewIframeReady,
        );
        toast.dismiss();
    }

    componentDidUpdate(prevProps) {
        each(this.previewRefs, (ref, size) => {
            if (ref.current) {
                dispatchCustomEvent(
                    "updatePromoPreview",
                    ref.current.contentWindow.document,
                    { detail: this.props.promo },
                );
            }
        });

        if (prevProps.match.params.slug !== this.props.match.params.slug) {
            this.setPromo();
        }

        if (this.props.redirectTo) {
            this.props.dispatch({
                type: REDIRECT_TO_UPDATED_PROMO,
                promo: null,
            });
        } else if (
            this.props.clonedPromo &&
            "new" !== this.props.match.params.slug
        ) {
            this.props.dispatch({
                type: REDIRECT_TO_UPDATED_PROMO,
                promo: {
                    ID: "new",
                },
            });
        }
    }

    handleFormChange(e) {
        if (document.getElementById("editor-form").contains(e.target)) {
            this.props.onChangeField(e);
        }
    }

    handlePreviewIframeReady(e) {
        dispatchCustomEvent("updatePromoPreview", e.detail, {
            detail: this.props.promo,
        });
    }

    setPromo() {
        this.props.dispatch({
            type: SET_PROMO,
            promo: null,
        });
        // We do a timeout to give the component a chance to render with a null promo.  That completely resets the form
        // component and seems to be important
        setTimeout(() => {
            if (
                this.props.match.params.slug &&
                "new" !== this.props.match.params.slug
            ) {
                tbkApi
                    .getPromotion(this.props.match.params.slug)
                    .then((promo) => {
                        if (promo) {
                            this.props.dispatch({
                                type: SET_PROMO,
                                promo,
                            });
                        }
                    });
            } else {
                this.props.dispatch({
                    type: SET_PROMO,
                    promo: this.props.clonedPromo || {
                        promo_style:
                            this.props.match.params.promo_style || "original",
                        type: this.props.match.params.type || "coupon",
                        design_option:
                            this.props.match.params.design_option ||
                            "plug_n_play",
                        layout: this.props.match.params.layout || "layout1",
                    },
                    clearCloned: !!this.props.clonedPromo,
                });
            }
        });
    }

    render() {
        if (!this.props.fields || !this.props.promo) {
            return "";
        } else if (
            this.props.redirectTo &&
            this.props.redirectTo !== this.props.location.pathname
        ) {
            return <Redirect to={this.props.redirectTo} push />;
        } else {
            let fields = {
                meta: {},
                content: {},
            };
            const apiBaseUrl = (
                process.env.REACT_APP_API_BASE ||
                "https://jiffylubeontario.com/jiffy-api/"
            ).replace(/\/$/, "");
            const uploadServer = { url: apiBaseUrl };

            Object.keys(this.props.fields).forEach((type) => {
                Object.keys(this.props.fields[type]).forEach((key) => {
                    let field = {
                        ...this.props.fields[type][key],
                    };
                    switch (field.type) {
                        case "image":
                            // IMPORTANT: top-level images like background_image need the upload server too
                            if (!field.choices) {
                                field.server = uploadServer;
                            }

                            field.onChange = (image, field) => {
                                this.props.dispatch({
                                    type: SET_PROMO_FIELD,
                                    field: field.name,
                                    value: image,
                                });
                            };
                            break;

                        case "gallery":
                            field.onChange = (image, field, checked) => {
                                let newValue = (field.value || []).splice(0);
                                if (checked) newValue.push(image);
                                else
                                    newValue = newValue.filter(
                                        (value) => value.ID !== image.ID,
                                    );

                                this.props.dispatch({
                                    type: SET_PROMO_FIELD,
                                    field: field.name,
                                    value: newValue,
                                });
                            };
                            break;

                        case "group":
                            field.sub_fields = (field.sub_fields || []).map(
                                (immutable) => {
                                    let sub_field = { ...immutable };

                                    // IMPORTANT: group images like promo_box_bc[desktop_large] need server.url too
                                    if (
                                        sub_field.type === "image" &&
                                        !sub_field.choices
                                    ) {
                                        sub_field.server = uploadServer;
                                    }

                                    return sub_field;
                                },
                            );
                            break;

                        default:
                            break;
                    }

                    // Putting the coupon permalink in here explicitly so Al Youssef can figure out the link for his coupon so he
                    // can link to it in his Advantage notification email
                    if (
                        "post_title" === key &&
                        this.props.promo &&
                        this.props.promo.permalink &&
                        "coupon" === this.props.promo.type
                    ) {
                        field.description = (
                            <small
                                style={{ position: "relative", top: "-1em" }}
                            >
                                Permalink:{" "}
                                <a
                                    href={this.props.promo.permalink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {this.props.promo.permalink}
                                </a>
                            </small>
                        );
                    }
                    fields[type][key] = field;
                });
                fields[type] = applyFieldValues(fields[type], this.props.promo);
            });
            const errors = this.props.response
                ? this.props.response.errors
                : null;
            return (
                <Form
                    id="editor-form"
                    className="jiffy--editor"
                    ref={this.formRef}
                    onSubmit={this.props.onSubmit}
                    onChange={this.handleFormChange}
                >
                    <input
                        type="hidden"
                        name="ID"
                        defaultValue={this.props.promo.ID}
                    />
                    <div className="jiffy--header">
                        <div className="navbar jiffy--navbar jiffy--navbar--editor">
                            <div className="jiffy--navbar__center">
                                <h1>
                                    {this.props.promo.ID && (
                                        <small className="text-muted">
                                            {"#" + this.props.promo.ID}
                                        </small>
                                    )}
                                    {!this.props.promo.ID && (
                                        <React.Fragment>
                                            <Alert bsStyle="warning">
                                                {t("NEW")}
                                            </Alert>
                                            &nbsp;
                                        </React.Fragment>
                                    )}
                                    {this.props.promo.post_title}
                                    {this.props.promo.post_status ===
                                        "draft" && (
                                        <Label>{t("Archived")}</Label>
                                    )}
                                    {this.props.promo.post_status ===
                                        "publish" && (
                                        <Label bsStyle="success">
                                            {t("Active")}
                                        </Label>
                                    )}
                                </h1>
                            </div>
                            <div className="jiffy--navbar__editor-controls">
                                {"new" !== this.props.match.params.slug && (
                                    <React.Fragment>
                                        <div className="jiffy--draft-saved">
                                            {this.props.promo.post_date ? (
                                                <React.Fragment>
                                                    {t("Created")}:{" "}
                                                    <span className="jiffy--date-saved">
                                                        <Moment
                                                            title={
                                                                this.props.promo
                                                                    .post_date
                                                            }
                                                            calendar
                                                            date={
                                                                this.props.promo
                                                                    .post_date
                                                            }
                                                        />
                                                    </span>
                                                    <br />
                                                </React.Fragment>
                                            ) : (
                                                ""
                                            )}
                                            {this.props.promo.post_modified ? (
                                                <React.Fragment>
                                                    {t("Last Updated")}:{" "}
                                                    <span className="jiffy--date-saved">
                                                        <Moment
                                                            title={
                                                                this.props.promo
                                                                    .post_modified
                                                            }
                                                            calendar
                                                            date={
                                                                this.props.promo
                                                                    .post_modified
                                                            }
                                                        />
                                                    </span>
                                                </React.Fragment>
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                        <ButtonGroup>
                                            <Button
                                                bsStyle="default"
                                                onClick={() =>
                                                    this.props.onClone(
                                                        this.props.promo,
                                                    )
                                                }
                                            >
                                                {t("Clone to New")}
                                            </Button>
                                            <DropdownButton
                                                pullRight
                                                bsStyle="default"
                                                title={t("Options")}
                                                id="editor-options-dropdown"
                                            >
                                                <MenuItem
                                                    eventKey={
                                                        this.props.promo.ID +
                                                        "1"
                                                    }
                                                    onClick={() =>
                                                        this.setPromo()
                                                    }
                                                >
                                                    {t(
                                                        "Cancel Unsaved Changes",
                                                    )}
                                                </MenuItem>
                                                <MenuItem divider />
                                                {"publish" ===
                                                this.props.promo.post_status ? (
                                                    <MenuItem
                                                        eventKey={
                                                            this.props.promo
                                                                .ID + "2"
                                                        }
                                                        onClick={() =>
                                                            this.props.onForceStatusChange(
                                                                this.props
                                                                    .promo,
                                                                "draft",
                                                            )
                                                        }
                                                    >
                                                        {t("Archive")}
                                                    </MenuItem>
                                                ) : (
                                                    <MenuItem
                                                        eventKey={
                                                            this.props.promo
                                                                .ID + "2"
                                                        }
                                                        onClick={() =>
                                                            this.props.onForceStatusChange(
                                                                this.props
                                                                    .promo,
                                                                "publish",
                                                            )
                                                        }
                                                    >
                                                        {t("Unarchive")}
                                                    </MenuItem>
                                                )}
                                                <MenuItem
                                                    className="jiffy--actions__publish"
                                                    eventKey={
                                                        this.props.promo.ID +
                                                        "3"
                                                    }
                                                    onClick={() =>
                                                        this.props.onDelete(
                                                            this.props.promo,
                                                        )
                                                    }
                                                >
                                                    {t("Delete Permanently")}
                                                </MenuItem>
                                            </DropdownButton>
                                        </ButtonGroup>
                                        &nbsp;
                                    </React.Fragment>
                                )}
                                <Button type="submit" bsStyle="success">
                                    {t("Save")}
                                </Button>
                            </div>
                        </div>
                        <Row>
                            <hr />
                        </Row>
                    </div>

                    <div className="container-fluid">
                        <Row>
                            <Col md={6} lg={3}>
                                <FormFields
                                    fields={fields.meta}
                                    errors={errors}
                                />
                            </Col>

                            <Col md={6} lg={3} className="well">
                                <FormFields
                                    fields={fields.content}
                                    otherFields={fields.meta}
                                    errors={errors}
                                    onTabSelect={this.props.onTabSelect}
                                />
                                <div className="clearfix"></div>
                            </Col>

                            {
                                <Col md={12} lg={6}>
                                    <div className="jiffy--editor__preview-container">
                                        {map(this.previewRefs, (ref, size) => (
                                            <div
                                                className={classNames(
                                                    "jiffy--preview__frame-wrapper",
                                                    "jiffy--preview__frame-wrapper-" +
                                                        size,
                                                )}
                                                key={size}
                                            >
                                                <iframe
                                                    ref={ref}
                                                    title={size}
                                                    src={
                                                        process.env
                                                            .REACT_APP_BASENAME +
                                                        "preview/"
                                                    }
                                                    className={classNames(
                                                        "jiffy--preview__frame",
                                                        "jiffy--preview__frame-" +
                                                            size,
                                                    )}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </Col>
                            }
                        </Row>
                    </div>
                    <div className="container-fluid">
                        <Row>
                            <hr />
                            <Col md={12}>
                                <div className="jiffy--editor__preview-bar">
                                    <h2>{t("Live Preview")}</h2>
                                    {!this.props.promo._preview_coupon && (
                                        <FormGroup>
                                            <ToggleButtonGroup
                                                bsSize="large"
                                                type="radio"
                                                name="preview_box"
                                                value={this.props.preview_box}
                                                onChange={
                                                    this.props.onChangePreview
                                                }
                                            >
                                                <ToggleButton
                                                    bsStyle="info"
                                                    value="a"
                                                >
                                                    {t("Box A")}
                                                </ToggleButton>
                                                <ToggleButton
                                                    bsStyle="info"
                                                    value="b"
                                                >
                                                    {t("Box B")}
                                                </ToggleButton>
                                                <ToggleButton
                                                    bsStyle="info"
                                                    value="c"
                                                >
                                                    {t("Box C")}
                                                </ToggleButton>
                                            </ToggleButtonGroup>
                                        </FormGroup>
                                    )}
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Preview
                                className="jiffy--site-preview--no-height"
                                promo={this.props.promo}
                                box={this.props.preview_box}
                            />
                        </Row>
                    </div>
                    <Footer />
                </Form>
            );
        }
    }
}

export default Reduxify(Editor);
